import { computed } from 'mobx';

export default class MetaDataTemplateModel {
  id;
  store;

  constructor(store, metaDataTemplate) {
    this.store = store;
    this.id = +metaDataTemplate.id;
    this.name = metaDataTemplate.name;
    this.description = metaDataTemplate.description;
    // this.meta_data = metaDataTemplate.meta_data;
    this.meta_data = (metaDataTemplate.meta_data && metaDataTemplate.meta_data.map(item => (
      this.store.metaDataStore.resolveItem(item)
    ))) || [];
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      meta_data: this.meta_data,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.meta_data = (json.meta_data && json.meta_data.map(item => (
      this.store.metaDataStore.resolveItem(item)
    ))) || [];
  }
}



// WEBPACK FOOTER //
// ./src/models/MetaDataTemplateModel.js